import React, { forwardRef, Ref } from 'react';
import { HTMLDivProps, Props } from '@blueprintjs/core';
import { SystemProps, x } from '@xstyled/emotion';

export interface BoxProps
  extends SystemProps, Props, Omit<HTMLDivProps, 'color'> {
  /** Arbitrary extra props are spread onto the underlying element. */
  mod?: unknown;
}

export const Box = forwardRef(
  ({ className, ...rest }: BoxProps, ref: Ref<HTMLDivElement>) => {
    const Element = x.div;

    return <Element className={className} ref={ref} {...rest} />;
  },
);
Box.displayName = '@leyona/Box';
